export interface GuiaSalida {
  idMovimiento: number;
  numeroGuia?: string;
  idDepositoOrigen?: number | null;
  direccionDestino?: string;
  motivoTraslado?: string;
  transportistaDescripcion?: string;
  placaVehiculo?: string;
  choferNombre?: string;
  choferDocumento?: string;
  choferLicencia?: string;
  fechaTraslado?: string | null;
  fechaMovimiento?: string;
  estado?: string;
  observaciones?: string;
  depositoOrigenNombre?: string;
}

export const initialGuiaSalidaState: Partial<GuiaSalida> = {
  numeroGuia: '',
  idDepositoOrigen: null,
  direccionDestino: '',
  motivoTraslado: '',
  transportistaDescripcion: '',
  placaVehiculo: '',
  choferNombre: '',
  choferDocumento: '',
  choferLicencia: '',
  observaciones: '',
};
